module.exports = __webpack_public_path__ + "static/media/logo-ticketmaster.360ad3ee.png";